/*
 | -------------------------------------------------------------
 |  --> type: component
 |  --> name: datatable
 | -------------------------------------------------------------
 |
 |  Functionality for datatable.
 |
*/

/* -------------------------------------------------------------
 | variables
 | -------------------------------------------------------------
 */

const datatables = [...document.querySelectorAll('.datatable__table')]

/* -------------------------------------------------------------
 | functions
 | -------------------------------------------------------------
 */

/* -------------------------------------------------------------
 | execution
 | -------------------------------------------------------------
 */

datatables && datatables.forEach(datatable => {
  // get all toggle buttons from the datatable
  const datatableTogglers = [...datatable.querySelectorAll('.datatable__toggle')]

  // click events
  datatableTogglers && datatableTogglers.forEach(datatableToggle => {
    datatableToggle.addEventListener('click', event => {
      // check if the event originated from a datatable row
      if (!event.target.closest('.datatable__row')) return

      // get the closest datatable row and their hidden cells
      const datatableRow = event.target.closest('.datatable__row')
      const datatableHiddenCells = [...datatableRow.querySelectorAll('.cell__collapsable')]

      // add the open class on click to the toggle button
      datatableRow.classList.toggle('open')

      // check whether the toggle contains the open class and toggle aria-expanded and hidden attributes
      if (datatableRow.classList.contains('open')) {
        datatableToggle.setAttribute('aria-expanded', true)
        datatableHiddenCells.forEach(hiddenCell => {
          hiddenCell.removeAttribute('hidden')
        })
      } else {
        datatableToggle.setAttribute('aria-expanded', false)
        datatableHiddenCells.forEach(hiddenCell => {
          hiddenCell.setAttribute('hidden', true)
        })
      }
    })
  })

  // keyboard events
  datatable.addEventListener('keydown', event => {
    // check if the event originated from a datatable row
    if (!event.target.closest('.datatable__row')) return

    // register the currently pressed key
    const key = event.key
    
    // get the current datatable row and toggler button
    const datatableRow = event.target.closest('.datatable__row')
    const currentToggle = datatableRow.querySelector('.datatable__toggle')
    
    // get all the toggler buttons from the datatable and set the index for the current toggle
    const datatableTogglers = [...datatable.querySelectorAll('.datatable__toggle')]
    const index = datatableTogglers.findIndex(item => item === currentToggle)
    
    // get all the hidden cells from the current datatable row
    const datatableHiddenCells = [...datatableRow.querySelectorAll('.cell__collapsable')]

    // when escaped is pressed check whether the toggle contains the open class and toggle aria-expanded and hidden attributes
    if (datatableRow.classList.contains('open') && key === 'Escape') {
      currentToggle.setAttribute('aria-expanded', true)
      datatableRow.classList.remove('open')
      datatableHiddenCells.forEach(hiddenCell => {
        hiddenCell.removeAttribute('hidden')
      })

      // set the focus back to the current toggle
      currentToggle.focus()
    }

    // move between toggles down
    if (key === 'ArrowDown') {
      event.preventDefault()
      // if it's the last item, go the first, else go to next
      if (datatableTogglers.indexOf(currentToggle) === datatableTogglers.length - 1) {
        datatableTogglers[0].focus()
      } else {
        datatableTogglers[index + 1].focus()
      }
    }

    // move between toggles up
    if (key === 'ArrowUp') {
      event.preventDefault()
      // if it's the first item, go the last, else go to next
      if (datatableTogglers.indexOf(currentToggle) === 0) {
        datatableTogglers[datatableTogglers.length - 1].focus()
      } else {
        datatableTogglers[index - 1].focus()
      }
    }
  })
})
